import React, { useContext, useEffect, useState } from 'react';
import Table from '../../../components/Table/Table';
import { momentTimeFormater } from '../../../utils/dateHelper';
import _, { get as LodashGet } from 'lodash';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';
import myClasses from '../SmartCharging.module.css';
import { UilListUl, UilTimesCircle } from '@iconscout/react-unicons';
import Typography from '../../../components/Typography/Typography';
import classes from '../../DemandResponse/DemandResponse.module.css';
import ModalComponent from '../../../components/ModalComponent/ModalComponent';
import ProfileModal from './ProfileModal';
import DeleteModal from '../../../components/DeleteModal/DeleteModal';
import { USER_ROLE } from '../../../constants';
import { AuthContext } from '../../../context/AuthContext';
import { SCService } from '../../../services/SCService';
import { useLoader } from '../../../hooks';
import buttonClasses from '../../../components/Buttons/Button.module.css';
import { toast } from 'react-toastify';
import { use } from 'react';
import ConfirmSendProfileModal from './ConfirmSendProfileModal';
import { UilSync } from '@iconscout/react-unicons';

const SmartChargeInfoModal = ({ setOpen, sessionId = '', evseId = '', fetchSessionData }) => {
    const { state } = useContext(AuthContext);
    const userRole = LodashGet(state, 'user.userRole');
    const [tableData, setTableData] = useState([]);
    const [startLoader, stopLoader] = useLoader();
    const [profileModal, setProfileModal] = useState({ status: false, data: {} });
    const [cancelConfirmModal, setCancelConfirmModal] = useState({ status: '', id: '' });
    const [sendProfileConfirmModal, setSendProfileConfirmModal] = useState({ status: '', id: '' });
    const [chargerGroup, setChargerGroup] = useState({});

    useEffect(() => {
        if (evseId) {
            getChargerGroup();
        }
    }, [evseId]);

    useEffect(() => {
        getChargingProfiles();
    }, [sessionId]);

    const getChargingProfiles = () => {
        if (sessionId) {
            SCService.GetChargingProfiles(
                sessionId,
                () => startLoader('getChargingProfiles'),
                handleChargingProfilesSuccess,
                handleTagGroupError,
                () => stopLoader('getChargingProfiles')
            );
        }
    };

    const handleChargingProfilesSuccess = ({ data }) => {
        const processedData = data?.data?.map((item) => {
            return {
                timestamp: item.createdAt ? momentTimeFormater(item.createdAt).format('YYYY-MM-DD HH:mm:ss') : '--',
                cpoStatus: item.status || '--',
                chargerStatus: item.evseStatus || '--',
                cancelCpoStatus: item.clearStatus || '--',
                cancelChargerStatus: item.clearEvseStatus || '--',
                soc: _.get(item, ['meta', 'currentSoC']),
                action: (
                    <div className={myClasses.ActionIcons}>
                        <div onClick={() => setProfileModal({ status: true, data: item })}>
                            <CustomTooltip content={'View Profile'}>
                                <UilListUl className={buttonClasses.ButtonIcon} />
                            </CustomTooltip>
                        </div>
                        {[USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) ? (
                            <div onClick={() => setCancelConfirmModal({ status: true, id: item._id })}>
                                <CustomTooltip content={'Cancel Profile'}>
                                    <UilTimesCircle className={buttonClasses.ButtonIcon} />
                                </CustomTooltip>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                ),
            };
        });
        setTableData(processedData);
    };

    const getChargerGroup = () => {
        SCService.GetChargerGroup(
            evseId,
            () => startLoader('getTagGroup'),
            handleTagGroupSuccess,
            handleTagGroupError,
            () => stopLoader('getTagGroup')
        );
    };

    const handleTagGroupSuccess = ({ data }) => {
        setChargerGroup(data.data?.groupData);
    };

    const handleTagGroupError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const handleCancelProfile = (profileId) => {
        SCService.CancelProfile(
            profileId,
            {},
            () => startLoader('cancelProfile'),
            handleCancelProfileSuccess,
            handleError,
            () => stopLoader('cancelProfile')
        );
    };

    const handleCancelProfileSuccess = () => {
        toast.success('Request Accepted by CPO');
        setOpen();
        fetchSessionData();
    };

    const handleError = (err) => {
        setOpen();
        fetchSessionData();
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    return (
        <div style={{ minWidth: '60vw' }}>
            <div className={myClasses.FilterContainer}>
                <div className={myClasses.HeadingContainer}>
                    <Typography content={`Charging Profiles`} />
                </div>
                <div style={{ display: 'flex', alignItems: 'end', gap: '1vw' }}>
                    {/* {[USER_ROLE.SUDOER, USER_ROLE.EXPERT].includes(userRole) && chargerGroup?.mode === 'siteLoadManagement' ? (<div
                        className={classes.SubmitButton}
                        onClick={() => setSendProfileConfirmModal({ status: true, id: sessionId })}
                    >
                        <button className="btn-primary" >
                            Send Charging Profile
                        </button>
                    </div>) : (
                        <></>
                    )} */}
                    <div onClick={() => getChargingProfiles()}>
                        <UilSync style={{ color: 'var(--color-primary)', cursor: 'pointer' }} size="1.2vw" />
                    </div>
                </div>
            </div>
            <Table
                head={['PROFILE SENT AT (CET)', 'CPO STATUS', 'CHARGER STATUS', 'PROFILE CREATION SOC (%)', 'CANCEL CPO STATUS', 'CANCEL CHARGER STATUS', 'ACTION']}
                keys={['timestamp', 'cpoStatus', 'chargerStatus', 'soc', 'cancelCpoStatus', 'cancelChargerStatus', 'action']}
                data={tableData}
            />
            <div className={classes.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>
            <ModalComponent isOpen={profileModal.status} setOpen={() => setProfileModal({ status: false, data: {} })}>
                <ProfileModal setOpen={() => setProfileModal({ status: false, data: {} })} data={profileModal.data} />
            </ModalComponent>
            <DeleteModal
                opendeleteModal={cancelConfirmModal.status}
                setOpenDeleteModal={() => setCancelConfirmModal({ status: false, id: '' })}
                deletefunction={handleCancelProfile}
                deviceId={cancelConfirmModal.id}
            />
            <ModalComponent isOpen={sendProfileConfirmModal.status} setOpen={() => setSendProfileConfirmModal({ status: false, id: {} })}>
                <ConfirmSendProfileModal setOpen={() => {
                    setSendProfileConfirmModal({ status: false, id: {} });
                    setOpen();
                }} id={sendProfileConfirmModal.id} />
            </ModalComponent>
        </div>
    );
};

export default SmartChargeInfoModal;
